module.exports = __webpack_public_path__ + "img/2_203.cc214182.png";